import { render, staticRenderFns } from "./LoginHead.vue?vue&type=template&id=c2262ad6&scoped=true&"
import script from "./LoginHead.vue?vue&type=script&lang=js&"
export * from "./LoginHead.vue?vue&type=script&lang=js&"
import style0 from "./LoginHead.vue?vue&type=style&index=0&id=c2262ad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2262ad6",
  null
  
)

export default component.exports